// @flow

import * as React from 'react';
import { CdnImage } from '@ta/common.cdn';

import styles from './ValuePropositionItem.less';

type ValuePropositionItemProps = {|
  header: React.Node,
  content: React.Node,
  imageSrc: string,
|};

const ValuePropositionItem = (props: ValuePropositionItemProps) => {
  const { header, content, imageSrc } = props;
  return (
    <div className={styles.ValuePropositionItemContainer}>
      <div className={styles.ValuePropositionImageWrapper}>
        <CdnImage src={imageSrc} alt="" />
      </div>
      <div className={styles.ValuePropositionText}>
        <h2 className={styles.header}>{header}</h2>
        <h3 className={styles.content}>{content}</h3>
      </div>
    </div>
  );
};

export default ValuePropositionItem;
